// extracted by mini-css-extract-plugin
export default {"Teams":"Teams_Teams__dEGa6"};